export enum Material {
  TELA = 'Tela',
  CUERO = 'Cuero o similar'
}
